// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { TeamsMeetingLinkLocator } from '@azure/communication-calling';
import { CallAndChatLocator } from '@azure/communication-react';
import { Constants } from '../constants';

export const locatorFromUrl = (): undefined | CallAndChatLocator | TeamsMeetingLinkLocator => {
  const searchParams = new URLSearchParams(window.location.search);

  const teamsMeetingLink = searchParams.get(Constants.TEAMS_MEETING_LINK_INDICATOR);
  if (teamsMeetingLink) {
    return { meetingLink: teamsMeetingLink };
  }

  const acsGroupId = searchParams.get(Constants.ACS_CALL_PARAM_NAME);
  const acsChatThreadId = searchParams.get(Constants.ACS_CHAT_PARAM_NAME);

  if (acsGroupId && acsChatThreadId) {
    return {
      callLocator: {
        groupId: acsGroupId
      },
      chatThreadId: acsChatThreadId
    };
  }

  // No locator found
  return undefined;
};
